import { ReactNode, useEffect } from 'react';

import { Main } from 'modules/App/Main';
import { NotFound } from 'modules/App/NotFound';
import { FormFM1 } from 'modules/FormFM1';
import { Admin } from 'modules/admin/admin';
import { Admins } from 'modules/admin/admins';
import { AdministrationRoute } from 'modules/administration/AdministrationRoute';
import { AccountingSystem } from 'modules/administration/accountingSystem';
import { OnboardingSettings } from 'modules/administration/onboardingSettings';
import { Login } from 'modules/auth/login';
import { LoginByToken } from 'modules/auth/loginByToken';
import { UpdateExpiredPassword, SetPassword } from 'modules/auth/setPassword';
import { TwoFactorConnection } from 'modules/auth/twoFactorConnection';
import { Client, ClientVersion } from 'modules/client/client';
import { Clients } from 'modules/client/clients';
import { CreateClient } from 'modules/client/createClient';
import { CreateLegalClient } from 'modules/client/createLegalClient';
import {
  LegalClient,
  LegalClientVersion,
} from 'modules/client/legal/containers';
import {
  LegalClientBeneficiary,
  LegalClientBeneficiaryVersion,
} from 'modules/client/legalClientBeneficiary';
import {
  LegalClientBranch,
  LegalClientBranchVersion,
} from 'modules/client/legalClientBranch';
import {
  LegalClientFirstHead,
  LegalClientFirstHeadVersion,
} from 'modules/client/legalClientFirstHead';
import {
  LegalClientHead,
  LegalClientHeadVersion,
} from 'modules/client/legalClientHead';
import {
  LegalClientLegalHead,
  LegalClientLegalHeadVersion,
} from 'modules/client/legalClientLegalHead';
import { LegalClients } from 'modules/client/legalClients';
import {
  LegalRepresentative,
  LegalRepresentativeVersion,
} from 'modules/client/legalRepresentative/containers';
import {
  RepresentativeClient,
  RepresentativeClientVersion,
} from 'modules/client/representativeClient';
import { CreateDirectoryRecord } from 'modules/directory/createDirectoryRecord';
import { Directories } from 'modules/directory/directories';
import { Directory } from 'modules/directory/directory';
import { DirectoryRecord } from 'modules/directory/directoryRecord';
import { ProductionCalendar } from 'modules/directory/productionCalendar';
import { CreateOperation } from 'modules/operation/createOperation';
import { Operation } from 'modules/operation/operation';
import { Operations } from 'modules/operation/operations';
import { CreateOrder } from 'modules/order/createOrder';
import { Order } from 'modules/order/order';
import { Orders } from 'modules/order/orders';
import { NotificationsSettings } from 'modules/settings/notifications';
import { PasswordSettings } from 'modules/settings/password';
import { TimezoneSettings } from 'modules/settings/timezone';
// eslint-disable-next-line no-restricted-imports
import { useNavigate } from 'react-router-dom';

import { useNavigationMenu } from '../hooks/useNavigationMenu';

import { RoutesId } from './routesId';

const NavigateToFirstMenuPath = () => {
  const navigate = useNavigate();
  const menu = useNavigationMenu();

  useEffect(() => {
    if (menu?.length) {
      navigate(menu[0].path, { replace: true });
    }
  }, [menu, navigate]);
  return null;
};

// Define a mapping of route IDs to React components or elements
export const PAGES: Record<RoutesId, ReactNode> = {
  [RoutesId.root]: <Main />,
  [RoutesId.notFound]: <NotFound />,
  // TODO: temporarily there is no home page yet
  [RoutesId.home]: <NavigateToFirstMenuPath />,
  [RoutesId.login]: <Login />,
  [RoutesId.loginByToken]: <LoginByToken />,
  [RoutesId.setPassword]: <SetPassword />,
  [RoutesId.twoFactorConnection]: <TwoFactorConnection />,

  [RoutesId.clients]: <Clients />,
  [RoutesId.personClients]: <Clients />,
  [RoutesId.personClient]: <Client />,
  [RoutesId.createPersonClient]: <CreateClient />,
  [RoutesId.personClientVersion]: <ClientVersion />,
  [RoutesId.legalClients]: <LegalClients />,
  [RoutesId.legalClient]: <LegalClient />,
  [RoutesId.createLegalClient]: <CreateLegalClient />,
  [RoutesId.legalClientVersion]: <LegalClientVersion />,
  [RoutesId.legalClientRepresentativeVersion]: <LegalRepresentativeVersion />,
  [RoutesId.legalClientHeadVersion]: <LegalClientHeadVersion />,
  [RoutesId.legalClientLegalHeadVersion]: <LegalClientLegalHeadVersion />,
  [RoutesId.legalClientFirstHeadVersion]: <LegalClientFirstHeadVersion />,
  [RoutesId.legalClientBeneficiaryVersion]: <LegalClientBeneficiaryVersion />,
  [RoutesId.legalClientBranchVersion]: <LegalClientBranchVersion />,
  [RoutesId.legalRepresentative]: <LegalRepresentative />,
  [RoutesId.representativeClient]: <RepresentativeClient />,
  [RoutesId.representativeClientVersion]: <RepresentativeClientVersion />,
  [RoutesId.legalClientHead]: <LegalClientHead />,
  [RoutesId.legalClientLegalHead]: <LegalClientLegalHead />,
  [RoutesId.legalClientFirstHead]: <LegalClientFirstHead />,
  [RoutesId.legalClientBeneficiary]: <LegalClientBeneficiary />,
  [RoutesId.legalClientBranch]: <LegalClientBranch />,
  [RoutesId.updateExpiredPassword]: <UpdateExpiredPassword />,

  [RoutesId.orders]: <Orders />,
  [RoutesId.order]: <Order />,
  [RoutesId.createOrder]: <CreateOrder />,

  [RoutesId.directories]: <Directories />,
  [RoutesId.directory]: <Directory />,
  [RoutesId.directoryRecord]: <DirectoryRecord />,
  [RoutesId.createDirectoryRecord]: <CreateDirectoryRecord />,
  [RoutesId.productionCalendar]: <ProductionCalendar />,

  [RoutesId.formFM1]: <FormFM1 />,

  [RoutesId.administration]: <AdministrationRoute />,
  [RoutesId.admins]: <Admins />,
  [RoutesId.admin]: <Admin />,
  [RoutesId.accountingSystem]: <AccountingSystem />,
  [RoutesId.onboardingSettings]: <OnboardingSettings />,

  [RoutesId.settings]: <TimezoneSettings />,
  [RoutesId.timezoneSettings]: <TimezoneSettings />,
  [RoutesId.passwordSettings]: <PasswordSettings />,
  [RoutesId.notificationsSettings]: <NotificationsSettings />,

  [RoutesId.operations]: <Operations />,
  [RoutesId.operation]: <Operation />,
  [RoutesId.createOperation]: <CreateOperation />,
};
